import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "services/redux/store";
import { ModeSwitch, SVG } from "ui";

const AccountDropdown = () => {
    const { avatar, name, userName } = useSelector(
        (state: RootState) => state.account
    );

    return (
        <div
            id="account-dropdown"
            className="navbar-item is-account drop-trigger has-caret"
        >
            <div className="user-image">
                <img
                    src={avatar}
                    // data-demo-src="assets/img/avatars/jenna.png"
                    alt=""
                />
                <span className="indicator"></span>
            </div>

            <div className="nav-drop is-account-dropdown">
                <div className="inner">
                    <div className="nav-drop-header">
                        <span className="username">{name}</span>

                        {/* <label className="theme-toggle" id="light-dark-toggler">
                            <input type="checkbox" />
                            <span className="toggler">
                                <span className="dark">
                                    <i data-feather="moon"></i>
                                </span>
                                <span className="light">
                                    <i data-feather="sun"></i>
                                </span>
                            </span>
                        </label> */}
                        <ModeSwitch />
                    </div>
                    <div className="nav-drop-body account-items">
                        <div id="profile-link" className="account-item">
                            <div className="media">
                                <div className="media-left">
                                    <div className="image">
                                        <img
                                            src={avatar}
                                            // data-demo-src="/assets/img/avatars/jenna.png"
                                            alt="user pic"
                                        />
                                    </div>
                                </div>
                                <div className="media-content">
                                    <h3>{name}</h3>
                                    <small>
                                        <Link to="/profile">@{userName}</Link>
                                    </small>
                                </div>
                                <div className="media-right">
                                    <i data-feather="check"></i>
                                </div>
                            </div>
                        </div>
                        <hr className="account-divider" />
                        <a href="/#" className="account-item momeento-p">
                            Create New Account
                        </a>
                        <a href="/#" className="account-item momeento-p">
                            Add Existing Account
                        </a>
                        <hr className="account-divider" />
                        <a
                            href="/options-settings.html"
                            className="account-item"
                        >
                            <div className="media">
                                <div className="icon-wrap">
                                    {/* <i data-feather="settings"></i> */}
                                    <SVG
                                        svg="settings"
                                        size={18}
                                        className="light-grey-svg"
                                    />
                                </div>
                                <div className="media-content">
                                    <h3>Settings</h3>
                                    <small>Access widget settings.</small>
                                </div>
                            </div>
                        </a>
                        <a className="account-item">
                            <div className="media">
                                <div className="icon-wrap">
                                    {/* <i data-feather="life-buoy"></i> */}
                                    <SVG
                                        svg="life-buoy"
                                        size={18}
                                        className="light-grey-svg"
                                    />
                                </div>
                                <div className="media-content">
                                    <h3>Help</h3>
                                    <small>Contact our support.</small>
                                </div>
                            </div>
                        </a>
                        <a className="account-item">
                            <div className="media">
                                <div className="icon-wrap">
                                    {/* <i data-feather="power"></i> */}
                                    <SVG
                                        svg="power"
                                        size={18}
                                        className="light-grey-svg"
                                    />
                                </div>
                                <div className="media-content">
                                    <h3>Log out</h3>
                                    <small>Log out from your account.</small>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountDropdown;
